import { transform, isPlainObject, snakeCase } from 'lodash'

export function toSnakeCase<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map(toSnakeCase) as unknown as T
  }

  if (!isPlainObject(obj)) {
    return obj
  }

  return transform(
    obj as Record<string, unknown>,
    (acc: Record<string, unknown>, value: unknown, key: string) => {
      const snakeKey = snakeCase(key)
      acc[snakeKey] =
        isPlainObject(value) || Array.isArray(value)
          ? toSnakeCase(value)
          : value
    },
    {} as Record<string, unknown>,
  ) as T
}
